export default __webpack_public_path__ + "media/metlife_350px_75px-05.png";